import { render, staticRenderFns } from "./AppBibleCopy.vue?vue&type=template&id=7dd333d0&"
import script from "./AppBibleCopy.vue?vue&type=script&lang=js&"
export * from "./AppBibleCopy.vue?vue&type=script&lang=js&"
import style0 from "./AppBibleCopy.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports